<div class="bloc-ami">
  <div class="container my-5">
    <div class="row py-3">
      <h3 class="text-uppercase">Vous allez adorer rencontrer <br> <span class="bleutdm">nos Conseillers en immobilier</span>
      </h3>
    </div>
    <div class="row row-cols-md-2 row-cols-sm-1 py-3">
      <div>
        <!--    <div class="img-bg-bloc-ami"><div class="img-bloc-ami"></div></div>-->
        <img width="651" height="537" src="assets/home/bloc-ami.webp" class="img-fluid" alt="Rencontrez nos Conseillers en immobilier">
      </div>
      <div class="align-self-md-center mt-4 mt-md-0">
        <p class="bold-base">THE DOOR MAN, c’est aussi un réseau national de Conseillers en immobilier. Leur
          mission ? Vous aider à réaliser vos plus beaux projets de vie.</p>
        <p>Pour vous accompagner, nos Conseillers peuvent compter au quotidien sur :</p>
        <ul>
          <li class=""><span class="bold-tdm">Des outils digitaux</span> développés sur-mesure pour leur activité</li>
          <li class=""><span class="bold-tdm">Des locaux dédiés</span> pour se retrouver, échanger et partager</li>
          <li class=""><span class="bold-tdm">Des formations continues</span> afin de toujours mieux vous servir</li>
        </ul>
        <p class="semibold-sm">Au sein du notre réseau immo, chaque Conseiller détient une place unique. Nous privilégions la
          confiance et la bienveillance, tout en vous offrant le meilleur de notre expertise.</p>
      </div>
    </div>
    <div *ngIf="showRejoindre === 'true'" class="row row-cols-md-2 row-cols-sm-1 py-3">
      <div class="ami-join-us-cta align-self-md-center text-center text-md-start">
        <div>
          <h4 class="text-uppercase">Et si vous deveniez <span class="bleutdm">Conseiller en
              immobilier ou indicateur d'affaires </span>
            ?
            Découvrez toutes nos opportunités !</h4>
        </div>
        <div class="text-center text-md-start my-3">
          <button (click)="onNavigateRejoindre()"
            class="btn btn-primary external-link-white px-4 my-1 py-2  fw-bold">Nous rejoindre</button>
        </div>
      </div>
      <div class="ami-join-us-pictur">
        <div class="text-end">
          <img width="800" height="533" class="w-100 h-auto" src="assets/home/bureau-tdm.webp" alt="Rejoignez The Door Man">
        </div>
      </div>
    </div>
  </div>
</div>
